import { Button, DialogActions, DialogContent, DialogTitle, List, MenuItem, Stack, Typography } from "@mui/material"
import { SelectComponent } from "components/controls/input/styled"
import LayersIcon from "components/icons/other/layers"
import SchemaIcon from "components/icons/other/schema"
import { useDialogStore } from "dialogs"
import { observer } from "mobx-react-lite"
import { useState } from "react"
import { useMainStore } from "store"
import Project from "store/project"
import { scrollbarStyle } from "styles/global-styles"
import ImportProjectStore from "./store"
import { MyListItem } from "./styled"
import { Data } from "./types"

type Props = {
  data: Data,
  project?: Project
}

const ImportProjectDialog = observer(({ data, project }: Props) => {

  const dialog = useDialogStore()
  const mainStore = useMainStore()
  const [ store ] = useState(() => new ImportProjectStore(mainStore, data, project || null))

  const apply = () => {
    const savedProjects = store.apply(mainStore)
    for (let project of savedProjects) {
      mainStore.saveProject(project)
      for (let content of project.contents.values()) {
        mainStore.saveContent(content)
        mainStore.saveSchema(mainStore.schemes.get(content.schemeId)!)
      }
    }
    for (let scheme of mainStore.schemes.values()) {
      mainStore.saveSchema(scheme)
    }
    mainStore.saveSchemes()
    console.log(mainStore.schemes)
    dialog.close()
  }

  return (
    <>
      { data.projects? ( 
        <DialogTitle sx={{ pb: 1 }}>{"Импорт " + (data.projects.length === 1? "проекта": "проектов")}</DialogTitle> 
      ): (
        <DialogTitle sx={{ pb: 1 }}>Импорт схем</DialogTitle>
      )}
      <Typography sx={{ px: 3, fontSize: 12, color: "text.secondary", fontWeight: 600 }}>
        { data.projects?.map(project => project.name).join(", ") }
      </Typography>
      <DialogContent sx={{ overflowX: "hidden", ...scrollbarStyle }}>
        <List disablePadding sx={{ width: 400 }}>
          { store.items.map(item => (
            <MyListItem key={item.content.id} disabled={item.action === "none"}>
              <LayersIcon sx={{ fontSize: 18 }}/>
              <Stack ml={1.5} flexGrow={1} spacing={0.3}>
                <Typography fontWeight={600} fontSize={12}>{ item.content.name }</Typography>
                <Typography fontSize={10}>{ item.scheme?.data.name }</Typography>
              </Stack>
              <SelectComponent 
                sx={{ flexBasis: 120 }} 
                value={item.action || ""}
                onChange={e => store.setActionValue(item, e.target.value as string)}
              >
                { item.conflict === "exists" && (
                  <MenuItem value="update">Обновить</MenuItem>
                ) }
                <MenuItem value="add">Добавить</MenuItem>
                <MenuItem value="none">Не ставить</MenuItem>
              </SelectComponent>
            </MyListItem>
          ))}
        </List>

        <List disablePadding sx={{ width: 400 }}>
          { store.schemes.map(item => (
            <MyListItem 
              key={item.scheme.id} 
              disabled={item.action === "none" || (item.blocks.length > 0 && !item.blocks.find(b => b.action !== "none"))}
            >
              <SchemaIcon sx={{ fontSize: 18 }}/>
              <Stack ml={1.5} flexGrow={1} spacing={0.3}>
                <Typography fontWeight={600} fontSize={12}>{ item.scheme.data.name }</Typography>
                <Typography fontSize={10} color={item.diff?.sum === 0? "text.secondary": "primary.dark" }>
                  { item.diff? (item.diff?.sum === 0? "Схемы совпадают": item.diff?.text): "Новая схема" }
                </Typography>
              </Stack>
              <SelectComponent 
                sx={{ flexBasis: 120 }} 
                value={item.action || ""}
                onChange={e => store.setActionValueScheme(item, e.target.value as string)}
                disabled={item.blocks.length > 0 && !item.blocks.find(b => b.action !== "none")}
              >
                { item.conflict === "exists" && (
                  <MenuItem value="update">Обновить</MenuItem>
                ) }
                <MenuItem value="add">Добавить</MenuItem>
                { !data.projects && ( <MenuItem value="none">Не ставить</MenuItem> )}
              </SelectComponent>
            </MyListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={apply} disabled={false} variant="contained" color="secondary">
          Добавить к проекту
        </Button>
      </DialogActions>
    </>
  )
})

export default ImportProjectDialog